<template>
  <div class="row m-t-sm" v-if="hasNext">
    <div class="flexbox justify-center">
      <a class="text--underline" @click.prevent="loadMore">
        もっと見る
      </a>
    </div>
  </div>
</template>

<script>
import PaginationService from '@/services/paginationservice'

export default {
  data () {
    return {
      data: [],
      allData: [],
      newData: [],
      originalData: [],
      currentPage: 0,
      hasNext: false,
      loader: null,
      needClear: false,
      isLoadMore: false,
      keepSort: false,
      isDestroy: false
    }
  },
  props: {
    url: {
      type: String,
      default: ''
    },
    maxRows: {
      type: Number,
      default: 50
    },
    loadingTableMode: {
      type: Boolean,
      default: false
    },
    clientMode: {
      type: Boolean,
      default: false
    },
    extraUrl: {
      type: Array,
      default () {
        return []
      }
    },
    extraUrlMode: {
      type: Boolean,
      default: false
    },
    needLoading: {
      type: Boolean,
      default: true
    },
    method: {
      type: String,
      default: 'get'
    },
    filters: {
      type: Object,
      default () {
        return {
          deliveryNo: '',
          deliveryAsin: '',
          deliveryDate: ''
        }
      }
    }
  },
  created () {
    const showLoading = this.needLoading && !this.clientMode
    this.fetchData(true, showLoading, false)
  },
  methods: {
    fetchData (needClear = false, showLoading = false, needAll = false, forceClient = false, isSearch = false) {
      this.currentPage = this.currentPage + 1
      if (showLoading) {
        this.loader = this.$loading.show({
          container: this.clientMode && this.$parent.$refs.table ? this.$parent.$refs.table : null
        })
      }
      this.needClear = needClear
      if ((!this.clientMode || this.currentPage === 1) && !needAll && !forceClient) {
        this.fetchDataByAPI(needAll, needClear)
      } else {
        this.fetchDataClientMode(false, true, null, isSearch)
        this.loader && this.loader.hide()
        this.$events.fire('done', this.url)
      }
    },

    loadMore () {
      if (!this.loader || !this.loader.active) {
        this.isLoadMore = true
        this.countLoadFunction = 0
        if (this.loadingTableMode) {
          this.fetchData(false, this.loadingTableMode)
        } else {
          this.loader = this.$loading.show()
          this.fetchData(false)
        }
      }
    },

    reload (showLoading = false, needAll = false, forceClient = false) {
      this.currentPage = 0
      this.fetchData(true, showLoading, needAll, forceClient)
    },

    fetchDataByAPI (needAll, needClear) {
      if (this.isDestroy) return
      let url = this.url
      let payload = {}
      const apiMethod = (this.method !== 'get') ? PaginationService.postDataByExtraUrl : PaginationService.getData
      apiMethod(url, payload)
        .then((response) => {
          this.allData = needClear ? [
            ...response.data
          ] : [
            ...this.allData,
            ...response.data
          ]
          this.originalData = needClear ? JSON.parse(JSON.stringify(response.data)) : JSON.parse(JSON.stringify([
            ...this.originalData,
            ...response.data
          ]))
          if (this.clientMode) {
            this.fetchDataClientMode()
          } else {
            this.newData = [...response.data]
            this.data = needClear ? [
              ...response.data
            ] : [
              ...this.data,
              ...response.data
            ]
            this.hasNext = this.currentPage < response.totalPage
          }
        })
        .catch((err) => {
          this.currentPage -= 1
          this.$store.commit('toggleModal', {
            show: true,
            message: err
          })
        })
        .finally(() => {
          this.loader && this.loader.hide()
          this.$events.fire('done', this.url)
        })
    },

    fetchDataClientMode (showFromStart = false, rowChanged = true, type = '', isSearch = false) {
      const startPage = 0
      const currentPage = this.currentPage > 0 ? this.currentPage : 1

      let deliveryNo = this.filters.deliveryNo
      let deliveryAsin = this.filters.deliveryAsin
      let deliveryDate = this.filters.deliveryDate
      if (deliveryNo || deliveryAsin || deliveryDate) {
        this.data = [...this.allData].filter((item) => {
          let asinInDeliveryNos = []
          let originalItem = this.originalData.find(originalDataItem => originalDataItem.deliveryNo === item.deliveryNo)
          let originalItemGoods = []
          if (originalItem) {
            originalItemGoods = originalItem.goods
          }
          if (deliveryAsin) {
            let goodRecords = item.goods.filter(product =>
              product.asin.toLowerCase().includes(deliveryAsin.toLowerCase())
            )
            if (goodRecords.length) {
              item.goods = goodRecords
              asinInDeliveryNos.push(item.deliveryNo)
            }
          } else {
            item.goods = originalItemGoods
          }
          return (
            (item.deliveryNo.toLowerCase().includes(deliveryNo.toLowerCase())) &&
            (item.deliveryDate === deliveryDate || !deliveryDate) &&
            (asinInDeliveryNos.includes(item.deliveryNo) || !deliveryAsin)
          )
        })

        if (rowChanged) {
          this.hasNext = currentPage < (this.data.length / this.maxRows)
        }
        this.data = this.data.slice(startPage * this.maxRows, currentPage * this.maxRows)
        if (this.isLoadMore || type === 'delete' || isSearch) {
          this.newData = this.data.slice((currentPage - 1) * this.maxRows, currentPage * this.maxRows)
        }
      } else {
        this.data = [...this.allData].slice(startPage * this.maxRows, currentPage * this.maxRows)
        if (rowChanged) {
          this.hasNext = currentPage < (this.allData.length / this.maxRows)
        }
        if (this.isLoadMore || type === 'delete' || isSearch) {
          this.newData = this.allData.slice((currentPage - 1) * this.maxRows, currentPage * this.maxRows)
        }
      }
    },

    handleData (item, type, isCallApi) {
      this.keepSort = !isCallApi
      this.needClear = true
      let rowChanged = true
      if (type === 'delete') {
        this.allData = this.allData.filter(data => data.deliveryNo !== item.deliveryNo)
        this.originalData = this.originalData.filter(data => data.deliveryNo !== item.deliveryNo)
      } else if (type === 'update') {
        rowChanged = false
        this.allData = this.allData.filter((data) => {
          if (data.deliveryNo === item.deliveryNo) {
            data.shippingInfo = item.shippingInfo
            data.shippingInfoSlice = (item.shippingInfo && item.shippingInfo.length > 20) ? `${item.shippingInfo.slice(0, 21)}...` : item.shippingInfo
          }
          return data
        })
      }
      this.fetchDataClientMode(true, rowChanged, type)
    }
  },

  watch: {
    data () {
      let newData = null
      if (this.isLoadMore) {
        newData = this.newData
        this.isLoadMore = false
      }
      this.$emit('onChangePage', this.data, this.needClear, this.keepSort, newData)
      if (this.needClear) {
        this.needClear = false
      }
      if (this.keepSort) {
        this.keepSort = false
      }
    },

    filters: {
      handler (filtersData) {
        this.currentPage = 0
        let deliveryNo = filtersData.deliveryNo
        let deliveryAsin = filtersData.deliveryAsin
        let deliveryDate = filtersData.deliveryDate
        let isSearch = false
        let isClientSide = false
        if ((deliveryNo !== null && deliveryNo !== '') || (deliveryAsin !== '') || (deliveryDate !== '')) {
          isSearch = true
        }
        if (this.clientMode && isSearch) {
          isClientSide = true
        }
        this.fetchData(true, true, isClientSide, isClientSide, isSearch)
        $('#delivery-list-table .collapse').collapse('hide')
      },
      deep: true
    }
  },
  beforeDestroy () {
    this.isDestroy = true
    this.loader && this.loader.hide()
    this.$store.commit('toggleModal')
  }
}
</script>



// WEBPACK FOOTER //
// src/view/deliveryRequests/components/DeliveryRequestsPagination.vue